export default {"src":"/_next/static/media/code.org.ae44ec51.ico","height":64,"width":64,"blurWidth":0,"blurHeight":0};